import React from 'react';
import { Link } from 'react-router-dom';
import { UserTacksShape, UserShape } from '../../shapes';
import QueuedUserTack from '../queued_user_tack';
import Waiting from '../waiting';
import PropTypes from 'prop-types';

export default class TackBoardQueuedTacks extends React.Component {
  static propTypes = {
    user: UserShape,
    userTacks: UserTacksShape,
    onFetchQueuedTacks: PropTypes.func
  }

  componentDidMount() {
    this.props.onFetchQueuedTacks();
  }

  render() {
    if (this.props.userTacks.get('error')) {
      return this.renderRetrievalError();
    } else if (this.props.userTacks.get('retrieving')) {
      return this.renderRetrieving();
    } else {
      return this.renderQueuedTacks();
    }
  }

  renderQueuedTacks() {
    if (this.props.userTacks.get('queued').size > 0) {
      const queuedTacks = this.props.userTacks.get('queued').map((queuedTack, i) => {
        return (
          <li key={ i }><QueuedUserTack tack={ queuedTack }/></li>
        );
      });

      return (
        <div className='user-tacks'>
          <div className='give-me-15-down'>
            <b>
              Queued Tacks: { this.props.user.get('queuedTacksCount') }
            </b>
            <p className='item-meta'><Link to='/plans'>Unlock the queue?</Link></p>
          </div>
          <ol>{ queuedTacks }</ol>
        </div>
      );
    } else {
      return (
        <div className='user-tacks'>
          <div className='give-me-15-down'>
            <b>
              Queued Tacks: { this.props.user.get('queuedTacksCount') }
            </b>
          </div>
          <b>No queued tacks. <Link to='/words/huzzah'>Huzzah</Link>!</b>
        </div>
      );
    }
  }

  renderRetrieving() {
    return(
      <Waiting waitingText={ 'Crunching' } />
    );
  }

  renderRetrievalError() {
    return(
      <div className='row tack-confirmation'>
        <div className='error col-sm-12' >
          { `Hmm. ${ this.props.userTacks.get('error') }.` }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/tack_board/tack_board_queued_tacks.jsx